module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_73-e9b5d4bcd05311e7d56cc308e03b61e0.png";